export default () => {
    (function($){
        // code pour le popup
        if($('.popup-option').length){
            if(!sessionStorage.getItem('popupOption')){
                setTimeout(() => { 
                    $('body').addClass('open-popup');
                }, 2000);
                
            }else{
                $('body').removeClass('open-popup');
            }

            $('body').on('click','.popup-option .closewrapper',function(e){
                sessionStorage.setItem('popupOption', true);
                $('body').removeClass('open-popup');
            });
        
            $('body').on('click','.popup-option',function(e){
                if($('body').hasClass('open-popup')){
                    if($(e.target).hasClass('popup-option')){
                        sessionStorage.setItem('popupOption', true);
                        $('body').removeClass('open-popup');
                    }
                }
            });

            $('body').on('click','.popup-option a[href]', function(e){
                e.preventDefault();
                sessionStorage.setItem('popupOption', true);
                window.location.replace($(this).attr('href'));
            });
        }

    })(jQuery);
}